export default "data:image/svg+xml;base64,"